// extracted by mini-css-extract-plugin
export var redoItem = "_ms-1";
export var redoTrigger = "_ms-0";